import { render, staticRenderFns } from "./ComplaintsPolicy.vue?vue&type=template&id=7bca2a3e&"
import script from "./ComplaintsPolicy.vue?vue&type=script&lang=js&"
export * from "./ComplaintsPolicy.vue?vue&type=script&lang=js&"
import style0 from "./ComplaintsPolicy.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports